import React from 'react'
import { components } from 'cng-web-lib'

import CecPostcodeConfigApiUrls from 'src/apiUrls/CecPostcodeConfigApiUrls'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/PathMap_CeCAdmin'

const {
  form: {
    CngAddForm
  }
} = components

function AddPage({ history, showNotification }) {
  return (

    <CngAddForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      history={history}
      bodySection={
        < FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"add"}
        />
      }
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}

      create={{
        url: CecPostcodeConfigApiUrls.CREATE_POSTCODE_CONFIG,
        successRedirect: pathMap.CEC_POSTCODE_CONFIG_LIST_VIEW
      }}
    />
  )

}


export default AddPage
